enum ApiMethod {
  PATCH = 'patch',
  GET = 'get',
  POST = 'post',
  DELETE = 'delete',
  PUT = 'put',
}

enum StatusCode {
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
}

const deleteFieldPhrase = 'empty';

export {ApiMethod, deleteFieldPhrase, StatusCode};
